import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom"
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import Footer from "../components/footer";
import Header, { AuthKey, AdminKey } from "../components/header";
import { productList } from "../components/productList";

export default function OrderContents() {
    const navigate = useNavigate();
    const adminKey = new URLSearchParams(useLocation().search)?.get('zxcv');
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const year = new URLSearchParams(useLocation().search)?.get('year');
    const title = `Order Content List for ${year}`;

    useEffect(() => {
        // Check if the user is an admin
        if (adminKey !== AdminKey)
            navigate('/');

        async function getOrders() {
            // Call the lambda to get the orders
            await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/getOrders?marker=" + AuthKey, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: '',
            })
            .then((res) => res.json())
            .then((data) => {
                setOrders(data.filter(o => new Date(o.orderDate).getFullYear().toString() === year));
                setLoading(false);
            });
        }
        if (orders.length === 0) {
            getOrders();
        }
    }, [orders, loading, adminKey, year, navigate]);

    if (loading)
        return (adminKey === AdminKey && <HelmetProvider>
            <Helmet title={title}/>
            <Header />
            <Box className="mainBox">
                <Box className="subMainBox">
                    <h1>Orders</h1>
                    <h3>Loading....</h3>
                </Box>
            </Box>
            <Footer />
        </HelmetProvider>);

    return (adminKey === AdminKey && <HelmetProvider>
        <Helmet title={title}/>
        <Header />
        <Box className="mainBox">
        <Box className="subMainBox">
            <h1>Order Details for {year}</h1>
            <Table size='small'>
                <TableHead  sx={{ fontWeight: "bold", backgroundColor: "#a0a0a0" }}>
                    <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Order Number</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Status</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Date</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Qty</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Items</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Sort the orders by date ascending, showing each of the items purchased */}
                    {orders.sort((a,b) => a.orderDate - b.orderDate).map((row, index) => {
                        var lastOrderId = '';
                        return (row.items.map(item => {
                            const ret = (
                                <TableRow hover key={index}>
                                    <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                        {lastOrderId !== row.orderId ? row.orderId : ''}    {/* only show orderId for the first item in the order */}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{row.status}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{new Date(row.orderDate).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}</TableCell>
                                    <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>{item?.quantity}</TableCell>
                                    <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                        {productList.filter(p => p.ProductID === item?.productId)[0]?.Title}
                                    </TableCell>
                                    <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item?.unitPrice / 100)}
                                    </TableCell>
                                </TableRow>
                            );
                            lastOrderId = row.orderId;
                            return ret;
                        })
                        );
                    })}
                </TableBody>
            </Table>
            <br />
            <br />
            <h1>Order Totals for {year}</h1>
            <Table size='small'>
                <TableHead  sx={{ fontWeight: "bold", backgroundColor: "#a0a0a0" }}>
                    <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Order Number</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Status</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Date</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Tax</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Sort the orders by date ascending, showing each order, totaling tax and order total */}
                    {(() => {
                        let orderTotals = 0;
                        let taxTotals = 0;
                        const sortedOrders = orders.sort((a,b) => a.orderDate - b.orderDate);
                        sortedOrders.forEach((row) => {
                            orderTotals += row.total;
                            taxTotals += row.tax;
                        });
                        return [
                            ...sortedOrders.map((row, index) => (
                                <TableRow hover key={index}>
                                    <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{row.orderId}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{row.status}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{new Date(row.orderDate).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}</TableCell>
                                    <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row.tax / 100)}
                                    </TableCell>
                                    <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row.total / 100)}
                                    </TableCell>
                                </TableRow>
                            )),
                            /* Show a final row with the totals for the year */
                            <TableRow hover key={'totals'}>
                                <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>Totals</TableCell>
                                <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}></TableCell>
                                <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}></TableCell>
                                <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(taxTotals / 100)}
                                </TableCell>
                                <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderTotals / 100)}
                                </TableCell>
                            </TableRow>
                        ];
                    })()}
                </TableBody>
            </Table>
            </Box>
        </Box>
        <Footer />
    </HelmetProvider>);
}